import styled from '@emotion/styled';

export const DropAreaWrapper = styled('div', { label: 'DropAreaWrapper' })`
    margin-bottom: 16px;
`;
